import React from 'react';
import { CountdownRing } from '../CountdownRing';
import { PillButton } from '../PillButton';
import { useBeats } from '../../hooks/useBeats';
const BEATS = [1000, 2100];
interface ScreenOpeningProps {
  remaining: number;
  paused: boolean;
  onContinue: () => void;
}
export function ScreenOpening({
  remaining,
  paused,
  onContinue
}: ScreenOpeningProps) {
  const beat = useBeats(BEATS);
  return <section className="flex h-full w-full flex-col items-center justify-center text-center" data-id="element-138" data-mp="36lvotc6wycgh">
      <div className="opacity-0-init animate-pop-in" data-id="element-139" data-mp="32llg3rrql7xx">
        <CountdownRing remaining={remaining} variant="hero" paused={paused} data-id="element-140" data-mp="32iz1j86fhs67" />
      </div>

      <p className="mt-5 font-body text-[11px] font-semibold uppercase tracking-[0.26em] text-solventum-primary opacity-0-init animate-fade-in" style={{
      animationDelay: '140ms'
    }} data-id="element-141" data-mp="3gdrnaocww4l8">
        Invest 30 seconds
      </p>

      <h1 className="mt-9 text-[29px] font-extrabold leading-[1.13] text-white opacity-0-init animate-fade-in-up" style={{
      animationDelay: '240ms'
    }} data-id="element-142" data-mp="2ixcih27fc9r1">
        Why do some cases not track as planned?
      </h1>

      <p className={`mt-4 max-w-[19rem] font-body text-[14px] leading-relaxed text-white/55 transition-[opacity,transform] duration-300 ease-out ${beat >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-143" data-mp="urhr7j7cx8s7">
        There may be a gap between the digital plan and what reaches the tooth.
      </p>

      <div className={`mt-9 transition-[opacity,transform] duration-300 ease-out ${beat >= 2 ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'}`} data-id="element-144" data-mp="6x6j5fxhqyhy">
        <PillButton variant="solid" size="md" onClick={onContinue} data-id="element-145" data-mp="gve1o37fhom2">
          Start
        </PillButton>
      </div>
    </section>;
}